export default {
  name: 'BlocHTML',
  functional: true,
  props: {
    html: String,
    form: {
      type: Object,
      default: {}
    }
  },
  render (h, context) {
    return h({
      template: `<div>${context.props.html}</div>`,
      data() {
        return {form: {...context.props.form}}
      }
  })
  }
}
